import React from 'react';

import { Button } from '@sopranodesign/pulse-components';

import { useConditional } from '../hooks/index';

const AddConditionalButton = props => {
  const { handleNewConditional } = useConditional();

  return (
    <Button variant="secondary" onClick={handleNewConditional} {...props}>
      + New Rule
    </Button>
  );
};

export default AddConditionalButton;
